import MenuDesktop from './navigation/desktop/menu';
import MenuMobile from './navigation/mobile/menu';
import {MenuLinkData, MenuLinks} from './navigation/shared/menu';
import {FlagData} from './navigation/mobile/menu/flags';

interface NavigationProps extends MenuLinks {
    currentCategoryIds?: string[];
    flags: FlagData[];
}

interface NavigationState extends MenuLinks {
    mobile: boolean;
}

export default class Navigation extends React.Component<NavigationProps, NavigationState> {

    initLoad: boolean;
    deferredCatalogLinks: MenuLinkData[];
    matchMediaMobile = window.matchMedia('(max-width: 770px)');

    constructor(props) {
        super(props);

        this.state = {
            catalogLinks: this.props.catalogLinks,
            otherLinks: this.props.otherLinks,
            mobile: this.matchMediaMobile.matches
        };

        this.onLoadCatalogLinks = this.onLoadCatalogLinks.bind(this);
        this.onUpdateCatalogLinks = this.onUpdateCatalogLinks.bind(this);
    }

    componentDidMount() {
        try {
            this.matchMediaMobile.addEventListener('change', (e) => {
                this.setState(Object.assign(this.state, {mobile: e.matches}));
            });
        } catch (e) {
            this.matchMediaMobile.addListener((e) => {
                this.setState(Object.assign(this.state, {mobile: e.matches}));
            });
        }
    }

    onLoadCatalogLinks(): JQuery.jqXHR|null {
        if (this.initLoad) {
            return null;
        }

        this.initLoad = true;

        return $j.getJSON('/design/navigation/catalogLinks/').done((data) => {
            this.deferredCatalogLinks = data;
        });
    }

    onUpdateCatalogLinks() {
        if (!this.deferredCatalogLinks || this.deferredCatalogLinks.length == 0) {
            return;
        }

        this.setState(Object.assign(this.state, {catalogLinks: this.deferredCatalogLinks}));
        this.deferredCatalogLinks = null;
    }

    render() {
        return (
            <>
                {!this.state.mobile && (
                    <MenuDesktop
                        currentCategoryIds={this.props.currentCategoryIds}
                        catalogLinks={this.state.catalogLinks}
                        otherLinks={this.state.otherLinks}
                        onLoadCatalogLinks={this.onLoadCatalogLinks}
                        onUpdateCatalogLinks={this.onUpdateCatalogLinks}
                    />
                )}

                {this.state.mobile && (
                    <MenuMobile
                        catalogLinks={this.state.catalogLinks}
                        otherLinks={this.state.otherLinks}
                        flags={this.props.flags}
                        onLoadCatalogLinks={this.onLoadCatalogLinks}
                        onUpdateCatalogLinks={this.onUpdateCatalogLinks}
                    />
                )}
            </>
        );
    }
}
